import styled from 'styled-components';

import {
  PAGE_PADDING_BOTTOM_PX,
  PAGE_PADDING_LEFT_PX,
  PAGE_PADDING_RIGHT_PX,
} from '../TestCaseRepository/TestCaseRepository.styled';

export const BULK_BAR_HEIGHT_PX = '80px';

export const ContainerStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: ${BULK_BAR_HEIGHT_PX};
  min-height: ${BULK_BAR_HEIGHT_PX};
  width: 100%;

  background: var(--ds-surface, var(--ds-fb-surface));
  box-shadow: var(--ds-shadow-overflow, var(--ds-fb-shadow-overflow));

  margin: 0 -${PAGE_PADDING_RIGHT_PX} -${PAGE_PADDING_BOTTOM_PX} -${PAGE_PADDING_LEFT_PX};
  padding: 0 ${PAGE_PADDING_RIGHT_PX} 0 ${PAGE_PADDING_LEFT_PX};

  position: sticky;
  bottom: -${PAGE_PADDING_BOTTOM_PX};
`;

export const SelectedIssuesCounterStyled = styled.div`
  color: var(--ds-text, var(--ds-fb-text));
  font-weight: 600;
  font-size: 16px;
`;

export const BulkCheckActionsWrapperStyled = styled.div`
  display: flex;
`;

export const BulkActionsWrapperStyled = styled.div`
  display: flex;
  gap: 16px;
`;

export const DropdownItemDeleteFromFolderStyled = styled.span`
  color: var(--ds-text-danger, var(--ds-fb-text-danger));
`;
